module.exports = "/_next/static/images/SendTheData-88238c0710a2826433ac484151cd49c5.webp";